import { render, staticRenderFns } from "./value.vue?vue&type=template&id=32f5cdba&"
var script = {}
import style0 from "./value.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f5cdba')) {
      api.createRecord('32f5cdba', component.options)
    } else {
      api.reload('32f5cdba', component.options)
    }
    module.hot.accept("./value.vue?vue&type=template&id=32f5cdba&", function () {
      api.rerender('32f5cdba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-table/value.vue"
export default component.exports